import { createTheme } from "@mui/material/styles";

export const theme = createTheme({
  palette: {
    primary: {
      main: "#00B9AE",
    },
    secondary: {
      main: "#464FC0ff",
    },
    green: "#119b49",
  },
  typography: {
    fontFamily: "Inter",
  },
});

export const rich_black = "#03312E";
export const rich_grey = "#43716E";
export const white_green = "#e9FFe9";
export const skobeloff = "#037171";
export const tiffany_blue = "#00b9ae";
